import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../shared/components/Text';

export const AllowedPaymentMethodTypesOptions = Object.values(PaymentMethodType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
